/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, names: NonNullable<unknown> }} Delete_Room_Blocked_Air_Handler_UnitsInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "The room is linked to an air handling unit ({names})" |
* | "other" | "The room is linked to air handling units ({names})" |
*
* @param {Delete_Room_Blocked_Air_Handler_UnitsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const delete_room_blocked_air_handler_units = /** @type {((inputs: Delete_Room_Blocked_Air_Handler_UnitsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Room_Blocked_Air_Handler_UnitsInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`The room is linked to an air handling unit (${i?.names})`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`The room is linked to air handling units (${i?.names})`);
		return /** @type {LocalizedString} */ ("delete_room_blocked_air_handler_units");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`La pièce est associée à une CTA (${i?.names})`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`La pièce est associée à des CTA (${i?.names})`);
		return /** @type {LocalizedString} */ ("delete_room_blocked_air_handler_units");
	}
});